import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list = Object.freeze([
  {
    id: '0',
    codice: 'A',
    value: 'Lavoro',
  },
  {
    id: '1',
    codice: 'C',
    value: 'Studio',
  },
]);

interface ListRegistrationReason {
  disabled?: boolean;
  required?: boolean;
  value?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  expatriationBan?: boolean;
  error?: boolean;
  label: string;
}

interface ListType extends ItemVM {
  codice: string;
}
const RegistrationReasonComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
  expatriationBan,
  label,
}: ListRegistrationReason): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`label-${label}`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`label-${label}`}
        id={`id-${label}`}
        name={`id-${label}`}
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {list
          .filter((item) => (expatriationBan ? item.id === '0' : true))
          .map((item: ListType) => (
            <MenuItem key={item.id} value={item.codice}>
              {item.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

RegistrationReasonComponent.displayName = 'Registration reason component of temporary practice';

const RegistrationReason = memo(RegistrationReasonComponent);

export default RegistrationReason as typeof RegistrationReasonComponent;
